export default __webpack_public_path__ + "static/media/instruccionesjuegocurp.9de81c9b.png";